import React from "react";
import {
  Card,
  CardMedia,
  Box,
  Typography,
  useTheme,
  Avatar
} from "@mui/material";
import PropTypes from 'prop-types';

const SponsorCard = ({ sponsor, sx = {} }) => {
  const theme = useTheme();

  return (
    <Card
      variant="outlined"
      sx={{
        width: '100%',
        height: '150px',
        borderRadius: 2,
        transition: 'all 0.3s ease',
        overflow: 'hidden',
        '&:hover': {
          boxShadow: theme.shadows[6],
          transform: 'translateY(-4px)'
        },
        ...sx
      }}
    >
      {sponsor.photo_url ? (
        <CardMedia
          component="img"
          image={sponsor.photo_url}
          alt={sponsor.name}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            objectPosition: 'center',
            backgroundColor: '#f8f9fa',
            p: 1
          }}
        />
      ) : (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: theme.palette.grey[100]
          }}
        >
          <Avatar
            variant="rounded"
            sx={{
              width: 60,
              height: 60,
              bgcolor: theme.palette.primary.light,
              color: theme.palette.primary.contrastText,
              fontSize: '1.5rem',
              fontWeight: 'bold',
              mb: 1
            }}
          >
            {sponsor.name?.charAt(0).toUpperCase() || 'P'}
          </Avatar>
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              fontSize: '0.75rem',
              textAlign: 'center',
              px: 1
            }}
          >
            {sponsor.name}
          </Typography>
        </Box>
      )}
    </Card>
  );
};

SponsorCard.propTypes = {
  sponsor: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    photo_url: PropTypes.string
  }).isRequired,
  sx: PropTypes.object
};

export default SponsorCard; 